import { Icon } from '../components/ui/Icon';
import type { ModuleSpec, Suite } from '../data/types/platform';

export interface ModulePageProps {
  system: Suite;
  module: ModuleSpec;
}

const HEALTH_LABEL: Record<ModuleSpec['health'], string> = {
  live: 'פעיל',
  gap: 'פער נתונים',
  anomaly: 'אנומליה',
};

const KPIS = [
  { l: 'מדד ראשי',     v: '—', s: 'מחושב' },
  { l: 'שינוי שבועי',  v: '—', s: 'Δ' },
  { l: 'טווח אמינות',  v: '—', s: 'p95' },
  { l: 'כיסוי נתונים', v: '—', s: '%' },
];

export function ModulePage({ system, module }: ModulePageProps) {
  return (
    <div className="module-page">
      <div className="mp-head">
        <div className="mp-eyebrow">
          <span>{system.en}</span>
          <span className="mp-sep">/</span>
          <span>{module.he}</span>
          {module.phase && <span className="mp-phase">{module.phase}</span>}
        </div>
        <h1>{module.he}</h1>
        <p className="mp-sub">{module.sub}</p>
        <div className="mp-meta">
          <span><Icon name="user" size={12} /> {module.owner}</span>
          <span className="mp-dot" />
          <span><Icon name="clock" size={12} /> {module.updated}</span>
          <span className="mp-dot" />
          <span className={'mp-health ' + module.health}>
            <span className="mp-health-dot" />
            {HEALTH_LABEL[module.health]}
          </span>
        </div>
      </div>

      <div className="mp-body">
        <div className="mp-kpis">
          {KPIS.map((k, i) => (
            <div className="mp-kpi" key={i}>
              <div className="mp-kpi-lbl">{k.l}</div>
              <div className="mp-kpi-v">{k.v}</div>
              <div className="mp-kpi-sub">{k.s}</div>
            </div>
          ))}
        </div>

        <div className="mp-panels">
          <div className="mp-panel">
            <div className="mp-panel-head">
              <div className="mp-panel-title">תצוגה ראשית</div>
              <div className="mp-panel-sub">גרף · {module.he}</div>
            </div>
            <div className="mp-panel-body">
              <div className="mp-placeholder">
                <Icon name="bar-chart-3" size={20} />
                <span>תוכן המודול יוצג כאן</span>
              </div>
            </div>
          </div>
          <div className="mp-panel">
            <div className="mp-panel-head">
              <div className="mp-panel-title">פירוט</div>
              <div className="mp-panel-sub">טבלה · {module.he}</div>
            </div>
            <div className="mp-panel-body">
              <div className="mp-placeholder">
                <Icon name="table-2" size={20} />
                <span>טבלת פירוט</span>
              </div>
            </div>
          </div>
        </div>

        {system.href && (
          <div className="mp-extlink">
            <span>
              <Icon name="external-link" size={14} /> לוח אינטיליגנציה מלא לאירועים זמין במערכת הקיימת:
            </span>
            <a href={system.href}>{system.href}</a>
          </div>
        )}
      </div>
    </div>
  );
}
